import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaInputTable'

type IcaInputTableProps = React.JSX.IntrinsicElements['tgdb-ica-input-table']

export const IcaInputTable = wrapWc<IcaInputTableProps>('tgdb-ica-input-table', [])
